import React from "react";

const FavoritesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M10 17L2.3314 9.0474C1.47892 8.1633 1 6.96429 1 5.71405C1 3.11055 3.03517 1 5.54569 1C6.75128 1 7.90749 1.49666 8.76 2.38071L10 3.66667L11.24 2.38071C12.0925 1.49666 13.2487 1 14.4543 1C16.9648 1 19 3.11055 19 5.71405C19 6.96429 18.5211 8.1633 17.6686 9.0474L13.8343 13.0237"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FavoritesIcon;
